import axios from 'axios';
import guService from "./GuService";
import Swal from "sweetalert2";
import GuService from "./GuService";

const crm = axios.create({
    baseURL: process.env.REACT_APP_CRM_API,
    headers: {
        'Authorization': guService.getLocalState('token')
    }
});

let alertaExibido = false;

crm.interceptors.response.use(undefined, async (error) => {
  if (error.response?.status === 401) {
    if (error.response?.data === "Acesso não permitido neste horário") {
      if (!alertaExibido) {
        alertaExibido = true;
        await Swal.fire({
          titleText: "Erro",
          text: "Horario não permitido",
          icon: 'error',
          timer: 5000
        });
        GuService.logout();
        GuService.redirectGU();
      }
    } else if(error.response?.data === "Token expirado") {
      if (!alertaExibido) {
        alertaExibido = true;
        await Swal.fire({
          titleText: "Sessão expirada",
          text: "O tempo de vida da sua sessão acabou. Faça login no módulo novamente.",
          icon: 'warning',
          timer: 5000
        });
        GuService.logout();
        GuService.redirectGU();
      }
    }
    return crm(error.config);
  }
  throw error;
});

export default crm;
